import type { AnySchema } from 'joi';

import { SchemaField } from '../../../../../objects/generic/serialization/schema-field';
import { UserResponseSchema } from '../../generic/user-response/user-response-schema';

import { UserResponseCreateOrgError } from './user-response-create-org-error';

export class UserResponseCreateOrgSchema extends UserResponseSchema {
  protected static readonly orgId = 'orgId';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public static readonly Defaults = class extends UserResponseSchema.Defaults {
    public static readonly orgId = undefined;
  };

  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: AnySchema } {
    const parameters = super.getSchemaDefinition();

    parameters[UserResponseCreateOrgSchema.error] = SchemaField.string(UserResponseCreateOrgSchema.Defaults.error)
      .optional()
      .valid(...Object.values(UserResponseCreateOrgError));
    parameters[UserResponseCreateOrgSchema.orgId] = SchemaField.string(
      UserResponseCreateOrgSchema.Defaults.orgId,
    ).optional();

    return parameters;
  }
}
